
import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import PricingHero from './components/PricingHero';
import PriceSimulator from './components/PriceSimulator';
import QuickPriceGrid from './components/QuickPriceGrid';
import VehicleComparison from './components/VehicleComparison';
import PricingFAQ from './components/PricingFAQ';
import PricingCTA from './components/PricingCTA';
import { useSEO } from '../../utils/seo';

export default function PricingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useSEO({
    title: 'Tarifs & Simulateur de Prix | Voyage Elite - Transfert Premium Alpes',
    description:
      'Calculez instantanément le prix de votre transfert premium vers les Alpes. Genève-Chamonix dès 250 €, Lyon-Courchevel dès 484 €. Simulateur interactif, prix fixes tout compris.',
    keywords:
      'tarifs transport ski, simulateur prix transfert, prix VTC Genève Chamonix, tarif chauffeur privé Alpes, devis transfert premium',
    canonical: '/tarifs',
    ogTitle: 'Tarifs & Simulateur de Prix - Voyage Elite',
    ogDescription:
      'Simulateur de prix interactif pour vos transferts premium vers les Alpes. Prix fixes, transparents et tout compris.',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Tarifs & Simulateur de Prix - Transfert Premium Alpes',
      description:
        'Simulateur de prix interactif et grille tarifaire complète pour les transferts vers les stations de ski des Alpes.',
    },
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <PricingHero />
      <PriceSimulator />
      <QuickPriceGrid />
      <VehicleComparison />
      <PricingFAQ />
      <PricingCTA />
      <Footer />
    </div>
  );
}
